






import { Component, Prop, Vue } from 'vue-property-decorator'

import LandingLayout from '@/layouts/LandingLayout.vue'

@Component({
  components: {
    LandingLayout
  }
})
export default class LayoutManager extends Vue {
  get layout() {
    return this.$route.meta.layout
  }
}
